import { twMerge } from 'tailwind-merge';
import { isEmpty } from '@witmetrics/utils/misc';
import { COLLECTION_VIEWS, type CollectionView } from '@witmetrics/unison-core';
import FileCollectionList from './FileCollectionList';
import FileCollectionGrid from './FileCollectionGrid';
import type { BaseFileCollectionProps } from './types';
import { classes } from './utils';

export {
  default as FileCollectionList,
  type FileCollectionListProps,
} from './FileCollectionList';
export {
  default as FileCollectionGrid,
  type FileCollectionGridProps,
} from './FileCollectionGrid';
export { default as FileItem, type FileItemProps } from './FileItem';
export {
  default as FileCollectionItem,
  type FileCollectionItemProps,
} from './FileCollectionItem';
export { default as ItemImage } from './ItemImage';
export type { BaseFileCollectionProps, BaseItemProps } from './types';

export interface FileCollectionProps extends BaseFileCollectionProps {
  defaultExpanded?: boolean;
  listClassName?: string;
  gridClassName?: string;
  parentFileCollectionId?: number;
  collectionView: CollectionView;
  onOpenFileCollection?: (fileCollectionId: number) => void;
}

export default function FileCollection({
  isFetchingData,
  defaultExpanded,
  className,
  listClassName,
  gridClassName,
  parentFileCollectionId,
  collectionView,
  fileCollections,
  files,
  onOpenFileCollection,
  ...props
}: FileCollectionProps) {
  const renderContent = () => {
    if (!hasFiles) return <div className={classes.empty}>No files</div>;
    return collectionView === COLLECTION_VIEWS.LIST ? (
      <FileCollectionList
        isFetchingData={isFetchingData}
        defaultExpanded={defaultExpanded}
        className={listClassName}
        fileCollections={fileCollections}
        files={files}
        {...props}
      />
    ) : (
      <FileCollectionGrid
        isFetchingData={isFetchingData}
        className={gridClassName}
        fileCollections={fileCollections}
        files={files}
        onOpenFileCollection={onOpenFileCollection}
        {...props}
      />
    );
  };

  const hasFiles = isFetchingData || !isEmpty([...fileCollections, ...files]);

  return (
    <div className={twMerge(classes.wrapper, className)}>{renderContent()}</div>
  );
}
